import React, { Component } from "react";
import axios from "axios";
import { Base_url } from "../../requester";
import Swal from "sweetalert2";
import ScrollAnimation from "react-animate-on-scroll";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { loadUser } from "../../actions/auth";
import setAuthToken from "../../utils/setAuthToken";
import store from "../../store";

class SignUpform extends Component {
  state = {
    fullname: "",
    email: "",
    password: "",
    cpassword: "",
    error: "",
    isLoading: false,
    showpassword: false,
    role: "user",
  };

  onSubmit = async (e) => {
    e.preventDefault();
    let { email, password, fullname, cpassword } = this.state;
    try {
      this.setState({ isLoading: true });
      const res = await axios.post(`${Base_url}/auth/signup`, {
        email,
        password,
        cpassword,
        fullname,
        subscription_type: this.props.sub ? "paid" : "free",
      });
      if (res.data.token) {
        this.setState({
          fullname: "",
          email: "",
          password: "",
          cpassword: "",
          isLoading: false,
        });
        setAuthToken(res.data.token);
        store.dispatch({
          type: "LOGIN_SUCCESS",
          payload: res.data,
        });
        this.props.loadUser();
        await Swal.fire("Signup", res.data.message, "success");
      }
      // if (res.data.status == "Success") {
      //   this.setState({
      //     fullname: "",
      //     email: "",
      //     password: "",
      //     cpassword: "",
      //     isLoading: false,
      //   });

      // }
    } catch (err) {
      if (err.response) {
        this.setState({ isLoading: false });

        const errors = err.response.data.errors;
        if (errors) {
          // errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
        }
      }
      await Swal.fire("Signup", err.response.data.message, "warning");
    }
  };
  render() {
    const { isLoading } = this.state;
    if (
      this.props.AuthLoading === false &&
      this.props.isAuthenticated &&
      this.props.user.role == "user"
    ) {
      if (
        this.props.user.subscription_type == "paid" &&
        this.props.user.subscription == false
      ) {
        return <Redirect to="/cardInfo" />;
      }
      return <Redirect to="/watchlist" />;
    }
    return (
      <ScrollAnimation
        delay={500}
        animateIn="animate__fadeIn"
        animateOnce={true}
      >
        <div className="row">
          <div className="col-10 col-md-8 m-auto p-4">
            <form onSubmit={this.onSubmit}>
              <div class="form-group">
                <label> Full Name</label>

                <input
                  type="fullname"
                  value={this.state.fullname}
                  onChange={(e) => this.setState({ fullname: e.target.value })}
                  class="form-control"
                  placeholder="Enter Full Name"
                />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  class="form-control"
                  placeholder="Enter email"
                />
                <small id="emailHelp" class="form-text text-muted">
                  We'll never share your email with anyone else.
                </small>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  type="password"
                  value={this.state.password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  class="form-control"
                  placeholder="Password"
                />
              </div>
              <div class="form-group">
                <label>Verify Password</label>
                <input
                  type="password"
                  value={this.state.cpassword}
                  onChange={(e) => this.setState({ cpassword: e.target.value })}
                  class="form-control"
                  placeholder="Confirm Password"
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                class="btn text-white br-15 px-4 hover-shade py-1 bg-sky zoom-in"
              >
                {isLoading && <i className="mr-1 fa fa-refresh fa-spin"></i>}{" "}
                Submit
              </button>
            </form>
          </div>
        </div>
      </ScrollAnimation>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  AuthLoading: state.auth.loading,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  loadUser,
})(SignUpform);
